module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-item-video"
  }, [_c('div', {
    staticClass: "video-container"
  }, [(_vm.data.mediaType === 'Video') ? _c('div', {
    staticClass: "video-wrapper"
  }, [_c('video', {
    attrs: {
      "controls": "",
      "onclick": "this.paused?this.play():this.pause();"
    }
  }, [_c('source', {
    attrs: {
      "src": ("https://www.develteam.com/userdata/media/" + (_vm.data.mediaUrl)),
      "type": "video/mp4"
    }
  }), _vm._v("\n                Your browser does not support the video tag.\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.data.mediaType === 'Youtube') ? _c('fake-youtube', {
    attrs: {
      "src": _vm.data.mediaUrl
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48f8617b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/MediaItems/MediaItemVideo.vue
// module id = 865
// module chunks = 2